rjm.ui.ChartBuilderNonTimeOptionsView = Backbone.View.extend(
  events:
    "keydown #cbDataLimitSize": "filterNonNumeric"
    "keyup #cbDataLimitSize": "changeDataLimitSize"
    "change #cbOrderDirection": "changeOrderDirection"
    "change #cbDataLimitSort": "changeSortBy"
    "change #cbDataLimitUnits": "changeDataLimitUnits"

  initialize: (options) ->
    if not options or not options.chartModel
      throw "InvalidConstructorArgs - ChartBuilderNonTimeOptionsView"

    _.bindAll this, "changeOrderDirection", "swapDirection", "changeSortBy", "changeDataLimitUnits", 
      "changeDataLimitSize", "filterNonNumeric", "generateTemplateData", "toggleDisable", "render"  
    #set incoming options
    @model = options.chartModel
    @dataLimitModel = @model.get("dataLimit")

    #bind model events
    @model.bind "change:isTimeOnXAxis", @toggleDisable
    @model.get('series').at(0).get("categorySet").bind "change:categorySelector", @toggleDisable
 
    return

  changeOrderDirection: (e) ->
    e.preventDefault()
    enumId = @$(e.target).val()
    if @dataLimitModel.get("isCategory")
      enumId = @swapDirection(enumId)
    @dataLimitModel.set direction: rjm.app.enums.orderDirection[enumId]
    @render()
    return

  #swap the direction for use with category type 
  swapDirection: (direction)->
    if direction is "ASCENDING"
      return "DESCENDING"
    if direction is "DESCENDING"
      return "ASCENDING"

  changeSortBy: (e) ->
    e.preventDefault()
    enumId = @$(e.target).val()
    @dataLimitModel.set isValue: (enumId is "value")
    @dataLimitModel.set isCategory: (enumId is "category")
    @dataLimitModel.set direction: rjm.app.enums.orderDirection[@swapDirection(@dataLimitModel.get("direction").serializedValue)]
    @render()
    return

  changeDataLimitUnits: (e) ->
    e.preventDefault()
    enumId = @$(e.target).val()
    @dataLimitModel.set units: rjm.app.enums.dataLimitUnit[enumId]
    @render()
    return

  changeDataLimitSize: (e) ->
    size = @$(e.target).val()
    
    #to avoid rendering the preview on every digit key stroke that is part of a multi digit number,
    #wait for half a second before rendering (making sure we only set the final size number)
    setTimeout (=> @dataLimitModel.set size: size  if size is@$(e.target).val()), 500
    return

  filterNonNumeric: (event) ->
    
    # Allow: backspace, delete, tab and escape
    
    # Allow: Ctrl+A
    
    # Allow: home, end, left, right
    if event.keyCode is 46 or event.keyCode is 8 or event.keyCode is 9 or event.keyCode is 27 or (event.keyCode is 65 and event.ctrlKey is true) or (event.keyCode >= 35 and event.keyCode <= 39)
      
      # let it happen, don't do anything
      return
    else
      
      # Ensure that it is a number and stop the keypress
      if (event.keyCode < 48 or event.keyCode > 57) and (event.keyCode < 96 or event.keyCode > 105)
        event.preventDefault()

  generateTemplateData: ->
    if @dataLimitModel.get("isCategory") && @dataLimitModel
      tempDirection = @swapDirection(@dataLimitModel.get("direction").serializedValue)
    else
      tempDirection = @dataLimitModel.get("direction").serializedValue
    #direction (top, bottom...)
    directionEnums: rjm.app.enums.orderDirection
    directionLabelProperty: "limitNames"
    direction: tempDirection
    #size
    size: (if @dataLimitModel then @dataLimitModel.get("size") else null)
    #unit (values, percent...)
    dataLimitUnitEnums: rjm.app.enums.dataLimitUnit
    dataLimitUnitLabelProperty: "names"
    dataLimitUnit: (if @dataLimitModel then @dataLimitModel.get("units").serializedValue else null)
    #sorting (value or name(alphabetically)) TODO: make this use enums?
    sortByEnum:
      value:
        name: "Value"
      category:
        name: "Name"
    sortByLabelProperty: "name"
    sortBy: (if @dataLimitModel then (if @dataLimitModel.get("isValue") then "value" else "category") else null)

  resetDataLimit: ->
    @dataLimitModel.set 
      size: 100
      units: rjm.app.enums.dataLimitUnit["PERCENT"]

  toggleDisable: ->
    if @model.getCurrentSeries().get("categorySet").hasSelectors() and not @model.get('isTimeOnXAxis')
      @$("#nonTimeOptionsInput").removeClass('blocked message')     
    else
      @$("#nonTimeOptionsInput").addClass('blocked message').attr('data-message', 'Set Time Interval to None, select a Category and add Values to Sort')      
      if not @model.isCohortChart() then @resetDataLimit()

  render: ->
    @$el.html ich.chartBuilderNonTimeOptions(@generateTemplateData())
    @toggleDisable()

    return @
)